import { BRAND } from "@/content";

/**
 * Official WhatsApp brand glyph (the speech-bubble with phone handle).
 * Designed to be used inside a circular green pill background.
 */
export function WhatsAppGlyph({ size = 22, color = "#FFFFFF", className = "" }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      width={size}
      height={size}
      fill={color}
      aria-hidden="true"
      className={className}
    >
      <path d="M27.06 4.94A15.93 15.93 0 0 0 15.96 0C7.16 0 0 7.16 0 15.96c0 2.82.74 5.56 2.15 7.99L0 32l8.27-2.17a16 16 0 0 0 7.69 1.96h.01c8.8 0 15.96-7.16 15.96-15.96 0-4.26-1.66-8.27-4.87-10.89zM15.97 29.1h-.01a13.18 13.18 0 0 1-6.71-1.84l-.48-.29-4.91 1.29 1.31-4.78-.31-.5a13.16 13.16 0 0 1-2.02-7.02c0-7.27 5.92-13.18 13.18-13.18 3.52 0 6.83 1.37 9.32 3.86a13.1 13.1 0 0 1 3.86 9.32c0 7.27-5.92 13.14-13.23 13.14zm7.24-9.86c-.4-.2-2.35-1.16-2.71-1.29-.36-.13-.62-.2-.89.2-.27.4-1.02 1.29-1.25 1.55-.23.26-.46.3-.86.1-.4-.2-1.68-.62-3.2-1.97-1.18-1.05-1.98-2.35-2.21-2.75-.23-.4-.02-.62.17-.82.18-.18.4-.46.6-.7.2-.23.27-.4.4-.66.13-.27.07-.5-.03-.7-.1-.2-.89-2.15-1.22-2.95-.32-.78-.65-.67-.89-.69-.23-.01-.5-.01-.76-.01-.27 0-.7.1-1.06.5s-1.4 1.37-1.4 3.34c0 1.97 1.43 3.87 1.63 4.13.2.27 2.82 4.3 6.83 6.04.96.41 1.7.66 2.28.84.96.31 1.83.27 2.52.16.77-.11 2.35-.96 2.69-1.88.33-.92.33-1.71.23-1.88-.1-.17-.36-.27-.76-.46z"/>
    </svg>
  );
}

/**
 * Build a WhatsApp link with a prefilled Arabic message.
 * Optionally include a unit code (e.g. "A") for higher conversion context.
 */
export function whatsappLink(unit, source = "landing-page") {
  const lines = [
    `مرحبًا، أنا مهتم بمشروع تاون هاوس الشامخة.`,
    unit ? `النموذج المفضل: نموذج ${unit}` : null,
    `هل أستطيع تحديد زيارة أو استلام التفاصيل؟`,
    `(${source})`,
  ].filter(Boolean);
  const text = encodeURIComponent(lines.join("\n"));
  const phoneClean = BRAND.phone.replace(/[^\d]/g, "");
  return `https://wa.me/${phoneClean}?text=${text}`;
}
